// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___j8PoW","layout":"layout___3QbZS","withnavbar":"withnavbar___1T8uz","main":"main___3sII6","fold":"fold___DVYJ7","sider":"sider___1MzQQ","logo":"logo___2mYsp","light":"light___itaQf","switchtheme":"switchtheme___2yfrc","anticon":"anticon___2NbLS","container":"container___3EIVM","content":"content___1IFYk","spin":"spin___2gVE5","bread":"bread___LxHOj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.less
// module id = 279
// module chunks = 3